<template>
  <section>
    <div v-title data-title="产品列表">
      <!-- <wv-search-bar
        :autofocus="false"
        v-model="productName"
        @search="onSearch"
        @cancel="onCancel"
        :show="false"
        minContentHeight="0px"
        placeholder="请输入产品名称"
      />-->

      <div class="search-bar" v-if="!issearch" style="background: #ee7310">
        <div class="search-logo">
          <img src="../../assets/img/logo.png" />
        </div>
        <div v-if="productName == ''" class="column-sort">
          <p>
            <span style="padding: 0">{{ currentFirstMenu }} ▼</span>
            <select @change="setType">
              <option
                v-for="(model, $index) in producttype"
                :key="$index"
                :value="model.id"
                :selected="currentFirstMenu == model.name"
              >
                {{ model.name }}
              </option>
            </select>
          </p>
        </div>
        <div v-if="productName != ''" class="input" @click="showsearch()">
          <i class="van-icon">
            <div class="van-image van-icon__image">
              <img
                src="data:image/png;base64,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"
                class="van-image__img"
                style="object-fit: contain"
              />
            </div>
          </i>
          <span class="placeholder" v-if="productName == ''">搜索商品</span>
          <span class="placeholder" v-if="productName != ''">{{
            productName
          }}</span>
        </div>
        <div class="wrap">
          <div class="collect">
            <img
              v-if="formset.WechatLogoUrl != ''"
              :src="formset.WechatLogoUrl"
              width="40"
              style="border-radius: 50px"
            />
            <img
              v-if="formset.WechatLogoUrl == ''"
              src="../../assets/logo.png"
              width="40"
              style="border-radius: 50px"
            />
          </div>
        </div>
      </div>
      <div id="listSort">
        <div class="sortdiv">
          <a
            :class="IsOrderBySaleCountDesc == null ? '' : 'active_a'"
            href="javascript:void(0)"
            @click="onClick(0)"
            >{{ IsOrderBySaleCountDesc == 1 ? "销 量 ▼" : "销 量 ▲" }}</a
          >
        </div>
        <div class="sortdiv">
          <a
            :class="IsOrderByPriceAsc == null ? '' : 'active_a'"
            href="javascript:void(0)"
            @click="onClick(1)"
            >{{ IsOrderByPriceAsc == 1 ? "价 格 ▼" : "价 格 ▲" }}</a
          >
        </div>
        <div class="sortdiv">
          <a
            :class="IsOrderByCommissionDesc == null ? '' : 'active_a'"
            href="javascript:void(0)"
            @click="onClick(2)"
            >{{ IsOrderByCommissionDesc == 1 ? "新 品 ▼" : "新 品 ▲" }}</a
          >
        </div>
      </div>

      <div class="my-search" v-if="issearch" style="background: #f3f3f3">
        <div class="search-top">
          <div
            class="van-search van-search--show-action"
            style="background: #ffffff"
          >
            <div class="van-search__content van-search__content--round">
              <div class="van-cell van-cell--borderless van-field">
                <div class="van-field__left-icon">
                  <i class="van-icon">
                    <div class="van-image van-icon__image">
                      <img
                        src="data:image/png;base64,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"
                        class="van-image__img"
                        style="object-fit: contain"
                      />
                    </div>
                  </i>
                </div>
                <div class="van-cell__value van-cell__value--alone">
                  <div class="van-field__body">
                    <input
                      type="search"
                      v-model="productName"
                      placeholder="请输入搜索关键词"
                      class="van-field__control"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="van-search__action">
              <div @click="issearch = false">
                <span v-if="productName != ''" @click="onSearch()">搜索</span>
                <span v-if="productName == ''">取消</span>
              </div>
            </div>
          </div>
        </div>
        <div class="hot-search">
          <div class="search-tags"></div>
          <p class="search-title">热门搜索</p>
          <div class="search-tags">
            <span
              v-for="(s, $index) in this.hotsearchtag"
              :key="$index"
              @click="searchtags(s)"
              class="van-tag van-tag--round van-tag--default"
              style="
                background-color: rgb(233, 233, 233);
                color: rgb(90, 90, 90);
              "
              >{{ s }}</span
            >
          </div>
        </div>
      </div>

      <!-- <div class="banner">
          <img src="../../assets/img/tj.png" class="banner-bg" />
        </div>-->

      <div
        class="home"
        style="width: 96%; margin-left: 2%; margin: 0 auto; overflow: hidden"
      >
        <div
          class="tags"
          style="padding-top: 90px"
          v-if="producttypeSecchild.length > 0"
        >
          <ul>
            <li
              :class="type == model.id ? 'active' : ''"
              v-for="(model, $index) in producttypeSecchild"
              :key="$index"
            >
              <img
                :src="model.icon"
                @click="tomustpushtoday(model.name, model.id)"
              /><span @click="tomustpushtoday(model.name, model.id)">{{
                model.name
              }}</span>
            </li>
          </ul>
        </div>
        <div
          class="tags"
          style="height: 85px"
          v-if="producttypeSecchild.length == 0"
        ></div>
        <!-- :on-refresh="refresh" -->
        <!-- <scroller
        v-if="!issearch"
        :on-infinite="infinite"
        style="position: relative;"
        ref="myScroller"
        noDataText="更多产品,敬请期待~"
      > -->
        <ul class="pros-list">
          <li
            class="inline-flex"
            v-for="(model, $index) in orderlist"
            :key="$index"
            @click="ProductDetail(model.Guid)"
          >
            <div class="pro-img">
              <a href="javascript:void(0)">
                <img :src="model.ProductFirstPic" />
              </a>
              <span
                style="background-size: 32px; padding: 1px 5px 10px"
                v-if="model.IsNew == 1"
                class="tag-new"
                >新品</span
              >
            </div>
            <div class="pro-desc">
              <a
                href="javascript:void(0)"
                class="title"
                style="max-height: 42px"
                >{{ model.ProductName }}</a
              >
              <p class="price">
                <span>
                  ￥
                  <b>{{ model.SatrtAmount }}</b>
                </span>
                <span class="gray">￥{{ model.PrimePrice }}</span>
              </p>
              <p class="flex">
                <span>已售:{{ model.ProductSaleCount }}</span>
                <span
                  v-if="LoginType == 4 && model.IsDistribute == 1"
                  class="btn-tag"
                  >赚￥{{ model.Commission }}</span
                >
                <span v-else class="btn-tag">立即预定</span>
                <!-- <span><img src="../../assets/img/shop.png" width="25"/></span> -->
              </p>
            </div>
          </li>
        </ul>
        <!-- </scroller> -->
      </div>
    </div>
    <div style="height: 40px"></div>
    <div class="back" @click="top" v-if="isshowtop">置顶</div>
  </section>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import { debug } from "util";

export default {
  name: "mustpushtoday",
  data: function () {
    return {
      isshowtop: false,
      currenttab: 0,
      borwser: this.GLOBAL.borwser,
      LoginType: -1, //(-1=未登录/4=家游客/5=直客)
      FirstInit: true, //首次加载（加载分页防止重复请求）
      popupVisible4: false,
      popupVisible3: false,
      popupVisiblediy: false,
      logourl: thumb,
      productName: "",
      scenicareaId: null,
      holtelId: null,
      issearch: false,
      formset: [],
      PageSize: 10,
      PageNum: 1,
      TotalCount: -1,
      IsOrderByPriceAsc: null,
      IsOrderBySaleCountDesc: 1,
      IsOrderByCommissionDesc: null,
      hotsearchtag: [
        "摩飞",
        "大宇",
        "北鼎",
        "法格",
        "BRUNO",
        "海氏",
        "康巴赫",
        "卡特马克",
        "科西",
      ],
      isCheckRole: 0, //是否校验角色
      orderlist: [],
      ProductTypes: [],
      SelectAll: [
        {
          label: "全部筛选",
          value: "0",
        },
      ],
      RecommendSort: [
        {
          label: "价格 高>低",
          value: 2,
        },
        {
          label: "价格 低>高",
          value: 1,
        },
      ],
      SelectAllItems: [],
      checkedItems: [],
      orderStateList: [],
      Advertises: [],
      tabs: ["销量高", "佣金高", "价格低"],
      producttype: [],
      producttypeSecchild: [],
      currentFirstMenu: "",
      isadd: false,
      type: 0,
    };
  },
  computed: {
    filterResult() {
      return this.defaultResult.filter((value) =>
        new RegExp(this.value, "i").test(value)
      );
    },
  },
  beforeRouteLeave(to, from, next) {
    if (from.name == "mustpushtoday") {
      var scrollTop = Math.floor(
        document.body.scrollTop ||
          document.documentElement.scrollTop ||
          window.pageXOffset
      );
      sessionStorage.askPositon = scrollTop;
      if (isNaN(sessionStorage.askPositon)) {
        sessionStorage.askPositon = 0;
        //this.$refs.myScroller.scrollTo(0, sessionStorage.askPositon, false);
      }
    }
    next();
  },
  beforeRouteEnter(t, from, next) {
    if (sessionStorage.fullPath != t.fullPath) {
      t.meta.keepAlive = false;
      sessionStorage.fullPath = t.fullPath;
    } else {
      t.meta.keepAlive = true;
    }
    next((vm) => {
      if (vm && vm.$refs.myScroller) {
        //通过vm实例访问this
        setTimeout(function () {
          document.title = "产品列表";
          if (isNaN(sessionStorage.askPositon)) {
            sessionStorage.askPositon = 0;
          }
          //vm.$refs.myScroller.scrollTo(0, sessionStorage.askPositon, false);
          document.documentElement.scrollTop = Math.floor(
            sessionStorage.askPositon
          );
        }, 0); //同步转异步操作
      }
    });
  },
  created: function () {
    var url = window.location.href;
    var loginType = this.GetRequest(url)["logintype"];
    if (loginType == "dis") {
      localStorage.setItem("loginType", 4);
    }
    var keyword = this.GetRequest(url)["keyword"];
    if (keyword != undefined && keyword != null && keyword.length > 0) {
      keyword = decodeURI(this.GetRequest(url)["keyword"]);
      this.productName = keyword;
    }
    var holtelId = this.GetRequest(url)["holtelId"];
    if (holtelId != undefined && holtelId != null && holtelId.length > 0) {
      this.holtelId = holtelId;
    }

    var scenicareaId = this.GetRequest(url)["scenicareaId"];
    if (
      scenicareaId != undefined &&
      scenicareaId != null &&
      scenicareaId.length > 0
    ) {
      this.scenicareaId = scenicareaId;
    }

    var type = this.$route.query.type;
    if (type != undefined && type != null && type != "") {
      var typeName = this.$route.query.typeName;
      typeName = decodeURIComponent(decodeURIComponent(typeName));
      this.ProductTypes = [{ name: typeName, type: type }];
      this.type = type;
    } else {
      this.ProductTypes = [{ name: "全部", type: 0 }];
      this.type = 0;
    }
    this.$http
      .get(this.GLOBAL.BASE_URL + "api/tbproduct/accessAllProductType", {
        params: {
          topId: 1,
        },
      })
      .then(function (d) {
        var rep = JSON.parse(d.bodyText);
        if (rep.Success) {
          //提示绑定成功
          this.producttype = rep.Data;
          this.autoSelectType();
        } else {
          Toast.fail(rep.Message);
        }
      });

    //this.GetAdvertise();
    this.InitProduct(0);
    this.InintChecklist();
  },
  mounted: function () {
    var url = window.location.href;
    var loginType = this.GetRequest(url)["logintype"];
    var isCheckRole = this.GetRequest(url)["ischeckrole"];
    if (loginType == "dis") {
      localStorage.setItem("loginType", 4);
    }
    if (isCheckRole == 1) {
      this.isCheckRole = 1;
    }
    var code = this.GetRequest(url)["code"];
    if (code != undefined) {
      //绑定微信
      console.info(code);
      this.BindWechat(code);
    }
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    top: function () {
      document.documentElement.scrollTop = 0;
      this.isshowtop = false;
    },
    handleScroll() {
      //方法一
      var top = Math.floor(
        document.body.scrollTop ||
          document.documentElement.scrollTop ||
          window.pageXOffset
      );
      if (top > 0) {
        this.isshowtop = true;
      } else {
        this.isshowtop = false;
      }
      var diff =
        document.documentElement.scrollHeight -
        document.documentElement.offsetHeight;
      if (document.documentElement.scrollTop >= diff - 100 && this.isadd) {
        if (
          this.$route.name == "mustpushtoday" &&
          this.formset.Page.HasNextPage
        ) {
          this.isadd = false;
          this.PageNum += 1;
          this.InitProduct(1);
        }
      }
      // this.$store.commit('changeRecruitScrollY', top) //离开路由时把位置存起来

      //方法二
      //如果获取不到高度可换成
      // this.nextTick(()=>{
      //     var top = (document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset)
      //     this.$store.commit('changeRecruitScrollY', top) //离开路由时把位置存起来
      //     console.log(top);
      // })
    },
    tomustpushtoday: function (typeName, type) {
      this.ProductTypes = [{ name: typeName, type: type }];
      this.type = type;
      this.PageNum = 1;
      this.TotalCount = -1;
      this.InitProduct(0);
      this.InintChecklist();
    },
    setType: function (e) {
      var type = parseInt(e.currentTarget.value);
      this.type = type;
      this.PageNum = 1;
      this.TotalCount = -1;
      this.currentFirstMenu = "";
      this.producttypeSecchild = [];
      this.autoSelectType();
      this.InitProduct(0);
      this.InintChecklist();
    },
    autoSelectType: function () {
      this.producttypeSecchild = [];
      for (var i = 0; i < this.producttype.length; i++) {
        if (parseInt(this.type) == this.producttype[i].id) {
          this.currentFirstMenu = this.producttype[i].name;
        }
        if (this.producttype[i].children.length > 0) {
          for (var j = 0; j < this.producttype[i].children.length; j++) {
            if (parseInt(this.type) == this.producttype[i].children[j].id) {
              this.currentFirstMenu = this.producttype[i].name;
            }
            if(parseInt(this.type) == this.producttype[i].id||parseInt(this.type) == this.producttype[i].children[j].id)
            {
            this.producttypeSecchild=this.producttype[i].children;
            }
          }
        }
        if (
          this.producttypeSecchild.length > 0 &&
          this.currentFirstMenu != ""
        ) {
            //二级分类展示
          break;
        }else{
        this.producttypeSecchild = [];
        }
      }
    },
    showsearch: function () {
      this.issearch = !this.issearch;
    },
    deltag: function () {
      this.ProductTypes = [];
      this.onSearch();
    },
    //根据产品类型搜索
    ToProductWithType: function (type) {
      this.checkedItems = [];
      this.checkedItems.push(type);
      this.onSearch();
    },
    //绑定微信
    BindWechat: function (code) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/bindwechat", {
          params: {
            code: code,
          },
        })
        .then(function (d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            //提示绑定成功
            window.location.href = this.GLOBAL.WEB_URL + "/#/app/home";
            Toast.success("保存成功啦");
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    InintChecklist: function () {
      var checkList = Vue.filter("filterdictbychecklist")(39);
      this.orderStateList = checkList;
    },
    onShow() {
      console.log("shown");
    },
    onHide() {
      console.log("hidden");
    },
    onQueryShow() {
      console.log("onQueryShow");
    },
    onQueryHide() {
      console.log("onQueryHide");
    },
    InitProduct: function (type) {
      this.$store.commit("showLoading");
      var data = {
        ProductName: this.productName,
        IsOrderByPriceAsc: this.IsOrderByPriceAsc,
        IsOrderBySaleCountDesc: this.IsOrderBySaleCountDesc,
        IsOrderByCommissionDesc: this.IsOrderByCommissionDesc,
        //ProductTypes: this.checkedItems,
        ScenicareaId: this.scenicareaId,
        HoltelId: this.holtelId,
        PageSize: this.PageSize,
        PageNum: this.PageNum,
      };
      if (this.ProductTypes.length > 0) {
        data.ProductTypes = [];
        if (this.type != 0) {
          data.ProductTypes.push(this.type);
        }
      }

      this.$http
        .post(this.GLOBAL.BASE_URL + "api/tbproduct/productpager", data, {
          emulateJSON: true,
        })
        .then(function (d) {
          this.isadd = true;
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.LoginType = rep.Data.LoginType;
            this.formset = rep.Data;
            this.TotalCount = this.formset.Page.Total;
            for (var i = 0; i < this.formset.List.length; i++) {
              if (this.formset.List[i].ProductName.length > 27) {
                this.formset.List[i].ProductName =
                  this.formset.List[i].ProductName.substring(0, 27) + "...";
              }
            }
            if (type != 1) {
              this.orderlist = [];
              this.formset.List.forEach((element) => {
                this.orderlist.push(element);
              });
              if (this.LoginType != -1) {
                this.$http
                  .get(this.GLOBAL.BASE_URL + "api/tbproduct/getwxinfo", {
                    params: {
                      url: location.href.split("#")[0],
                    },
                  })
                  .then(function (d) {
                    var rep = JSON.parse(d.bodyText);
                    if (rep.Success) {
                      wx.config({
                        debug: false, // 开启调试模式,
                        appId: rep.Data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                        timestamp: rep.Data.timpstamp, // 必填，生成签名的时间戳
                        nonceStr: rep.Data.nonceStr, // 必填，生成签名的随机串
                        signature: rep.Data.sign, // 必填，签名，见附录1
                        jsApiList: [
                          "updateAppMessageShareData",
                          "updateTimelineShareData",
                        ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                      });
                    } else {
                      Toast.fail(rep.Message);
                    }
                  });
              }

              let that = this;
              wx.ready(function () {
                //需在用户可能点击分享按钮前就先调用
                wx.updateAppMessageShareData({
                  //分享给朋友和qq
                  title: "壹选生活优选商城", // 分享标题
                  desc:
                    "壹选生活，品质生活为您精挑细选，总有一款特色的产品是您想要的！", // 分享描述
                  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl:
                    "http://nongjiam.zhoumochuyou.cn/api/Attachment/downloadadvertiseimg?id=temp/logo0001.png", // 分享图标
                  success: function () {
                    //alert(location.href);
                  },
                });

                wx.updateTimelineShareData({
                  //分享给朋友圈和qq空间
                  title: "壹选生活优选商城", // 分享标题
                  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl:
                    "http://nongjiam.zhoumochuyou.cn/api/Attachment/downloadadvertiseimg?id=temp/logo0001.png", //that.formset.ProductImgUrl[0], // 分享图标
                  success: function () {},
                });
                wx.error(function (err) {
                  //alert(JSON.stringify(err));
                });
              });
            } else {
              this.formset.List.forEach((element) => {
                this.orderlist.push(element);
              });
            }
          } else {
            Toast.fail(rep.Message);
          }
          this.$store.commit("hideLoading");
        });
    },
    onSearch(val) {
      this.$store.commit("showLoading");
      this.PageNum = 1;
      // 自定义搜索处理
      this.InitProduct(0);
    },
    searchtags: function (val) {
      this.issearch = false;
      this.productName = val;
      this.onSearch();
    },
    onCancel(val) {
      // 自定义取消事件处理
    },

    //产品详情
    ProductDetail: function (orderGuid) {
      if (this.LoginType == 4) {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid,
            disid: this.formset.DisGuid,
          },
        });
      } else {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid,
          },
        });
      }
    },

    refresh: function (done) {
      //下拉
      var self = this;
      setTimeout(function () {
        self.PageNum = 1;
        self.InitProduct(0);
        done();
      }, 1500);
    },
    infinite: function (done) {
      // var self = this;
      // setTimeout(function() {
      //   if (self.FirstInit) {
      //     self.FirstInit = false;
      //     if (self.formset.List &&self.TotalCount == self.formset.List.length) {
      //       self.$refs.myScroller.finishInfinite(true);
      //       return;
      //     }
      //   }
      //   self.PageNum += 1;
      //   self.InitProduct(1);
      //   done();
      //   if (self.formset||self.formset.List||self.formset.List.length == 0) {
      //     self.$refs.myScroller.finishInfinite(true);
      //     return;
      //   }
      // }, 500);
    },
    SortChange(val) {
      this.popupVisible4 = false;
      this.PageNum = 1;
      // 自定义搜索处理
      this.InitProduct(0);
    },

    btnClose: function () {
      this.popupVisible3 = false;
    },
    btnSearch: function () {
      this.PageNum = 1;
      this.InitProduct(0);
      this.popupVisible3 = false;
    },
    toAdvertise: function (url) {
      window.location.href = url;
    },
    onClick: function (index) {
      this.$store.commit("showLoading");
      this.currenttab = index;
      if (index == 0) {
        //销量高
        if (this.IsOrderBySaleCountDesc == 1) {
          this.IsOrderBySaleCountDesc = 0;
        } else {
          this.IsOrderBySaleCountDesc = 1;
        }
        this.IsOrderByPriceAsc = null;
        this.IsOrderByCommissionDesc = null;
      } else if (index == 1) {
        //价格
        if (this.IsOrderByPriceAsc == 0) {
          this.IsOrderByPriceAsc = 1;
        } else {
          this.IsOrderByPriceAsc = 0;
        }
        this.IsOrderBySaleCountDesc = null;
        this.IsOrderByCommissionDesc = null;
      } else if (index == 2) {
        //时间
        if (this.IsOrderByCommissionDesc == 1) {
          this.IsOrderByCommissionDesc = 0;
        } else {
          this.IsOrderByCommissionDesc = 1;
        }
        this.IsOrderBySaleCountDesc = null;
        this.IsOrderByPriceAsc = null;
      }
      this.PageNum = 1;
      // 自定义搜索处理
      this.InitProduct(0);
    },
    GeneratePoster: function () {
      this.popupVisiblelogo = false;
      this.$store.commit("showLoading");
      var data = {};
      this.$http
        .post(
          this.GLOBAL.BASE_URL + "api/tbproduct/generateinvitationposter",
          data,
          {
            emulateJSON: true,
          }
        )
        .then(function (d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.posterbase64 = rep.Data;
            this.popupVisiblediy = true;
          } else {
            Toast.fail(rep.Message);
          }

          this.$store.commit("hideLoading");
        });
    },
    toweeklynewproduct: function () {
      this.$router.push("/page/weeklynewproduct");
    },
    tospecialevent: function () {
      this.$router.push("/page/specialevent");
    },
  },
  watch: {
    SelectAllItems: function (val) {
      this.checkedItems = [];
      if (val == "0") {
        this.orderStateList.forEach((element) => {
          this.checkedItems.push(element.value);
        });
      }
    },
  },
};
</script>




<style>
#listSort {
  position: fixed;
  margin-top: 57px;
  display: flex;
  width: 100%;
  background-color: #fff;
  height: 30px;
  line-height: 30px;
  z-index: 9;
  border-bottom: 1px solid #ddd;
}

.active_a {
  color: rgb(238, 115, 16);
}
.active_a:hover {
  color: rgb(238, 115, 16);
}

.sortdiv {
  width: 33.3333%;
  text-align: center;
  font-size: 16px;
}

.combo-price {
  color: red;
  font-size: 1.17rem;
}
.combo-qi {
  font-size: 0.75rem;
  color: #999;
}
.wv-button {
  float: right;
  margin-right: 5%;
}
.weui-form-preview__hd {
  line-height: 1.5em;
}

.weui-media-box__date {
  float: right;
}

.weui-form-preview__btns {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  padding-bottom: 5px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: #3cc51f;
  display: block;
  flex: 1;
  position: relative;
}

.weui-media-box__content {
  text-align: right;
  float: right;
  width: 100%;
  font-size: 14px;
}

.fontsf {
  font-size: 14px;
  color: #000;
}

.fontsn {
  font-size: 14px;
}

.weui-form-preview__border {
  height: 10px;
  background-color: #efeff4;
}

.weui-search-bar {
  z-index: 9999;
}

.popup {
  z-index: 9998;
  position: relative;
  background-color: #fff;
  line-height: 2em;
  padding-top: 70px;
  font-size: 1.5rem;
}

.search_left {
  width: 50%;
  text-align: center;
  float: left;
  background-color: #fff;
}

.weui-cells {
  margin-top: 0px;
}
.weui-zdycolors {
  color: #999;
}
.weui-spaces {
  height: 10px;
  background-color: #efeff4;
}
.needtomargin-top-wx {
  padding-top: 40px;
}
.needtomargin-top-common {
  padding-top: 90px;
}
</style>













// WEBPACK FOOTER //
// src/components/mustpushtoday/mustpushtoday.vue